<script setup lang="ts">
import { computed } from "vue";

import { getFieldNames } from "./getNames";
import CaseSearchFieldDescription from "./CaseSearchFieldDescription.vue";

import type { OptionsFilterField } from "@/models/Column";

withDefaults(defineProps<{
  config: OptionsFilterField;
  fieldPath: string;
  displayName: string;
  isCollection: boolean;
  lastSearch?: { value?: string | Array<string | number> };
}>(), {  })

const { fieldTypeName, fieldValueName, fieldParseAsName, fieldIsCollectionName, fieldHelpTextId } = getFieldNames(
  __props.fieldPath,
  __props.config,
);

const defaultValue = computed(
  () =>
    new Set(
      [__props.lastSearch?.value || __props.config.defaultValue]
        .flat()
        .filter((i) => i != null)
        .map(String),
    ),
);
</script>
<template>
  <div class="max-w-md tw-relative tw-shrink-0 tw-space-y-1">
    <label
      tabindex="0"
      :for="fieldValueName"
      class="tw-block tw-text-sm tw-font-medium tw-underline-offset-2 tw-outline-none focus:tw-underline"
    >
      {{ displayName }}
    </label>
    <CaseSearchFieldDescription v-if="config.helpText" :id="fieldHelpTextId" :help-text="config.helpText" />
    <input type="hidden" :name="fieldTypeName" value="select" />
    <input type="hidden" :name="fieldParseAsName" :value="config.parseAs" />
    <input type="hidden" :name="fieldIsCollectionName" :value="isCollection" />
    <select
      :id="fieldValueName"
      :name="fieldValueName"
      :multiple="config.multiple"
      :aria-label="config.description"
      :aria-describedby="config.helpText ? fieldHelpTextId : undefined"
      :size="config.multiple ? 3 : undefined"
      :disabled="(config.options ?? []).length === 0"
      class="tw-w-full tw-rounded-md tw-border tw-border-gray-500 tw-bg-white tw-p-2 disabled:tw-bg-gray-300"
    >
      <option v-if="!config.multiple" value=" ">
        {{ config.emptyLabel }}
      </option>
      <option
        v-for="option in config.options ?? []"
        :key="option.value"
        :value="option.value"
        :selected="defaultValue.has(String(option.value))"
        class="tw-py-1.5 tw-pl-1"
      >
        {{ option.label ?? option.value }}
      </option>
    </select>
  </div>
</template>
